// The replacement maps still staged for review in public/textures/next/ (real
// mission data in place of the Solar System Scope maps), by textureUrls key.
// /viewer/?tex=next on a local server swaps them in so the old and new can be
// compared; each leaves this list when it is promoted to public/textures/.
// See docs/textures/. A null removes a map.
export const NEXT_TEXTURES = {
  // Sharper than today's at mid range but over-processed at the default view.
  mars: 'mars.jpg',
  // About equal to today's: Voyager's 1989 features, OPAL 2025 colour.
  uranus: 'uranus.jpg',
  neptune: 'neptune.jpg',
  // NASA Blue Marble NG (June 2004), Black Marble 2016, NOAA ETOPO 2022, fitted
  // to the approved look; the ocean mask rebuilt to the new coast
  // (docs/textures/earth.md). The cloud map was already NASA's.
  // 8K, New Horizons where it is sharp; below what it resolved on the far side
  // and across the never-seen south, detail drawn by gpt-image-2 that equals
  // the data once low-passed to the local resolution (docs/textures/pluto.md).
  pluto: 'pluto.jpg',
  // 8K from the USGS Galileo/Voyager ClrMerge in NASA's true colour, centred
  // on 180 E like the other Galilean maps; detail below the mosaic's local
  // resolution drawn the same way (docs/textures/io.md).
  io: 'io.jpg',
  earth: 'earth.jpg',
  earth_night: 'earth_night.jpg',
  earth_normal: 'earth_normal.jpg',
  earth_specular: 'earth_specular.jpg',
  earth_ocean: 'earth_ocean.webp',
};

// Staged maps that already tile at the 0/360 meridian: the viewer skips the
// SEAMLESS_TEXTURE_EDGE_FIXES blend for them (it mirrors the edges and drops
// the mipmaps). Io's entry there is for today's cropped map; remove it when
// the new one is promoted.
export const NEXT_SEAMLESS = new Set(['io']);
